@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.todo-cards-section {
  margin: @space-48 @space-0 @space-48 @space-0;
  overflow: visible;
}

.section-header {
  display: flex;
  align-items: center;
  gap: @space-8;
  cursor: pointer;
}

.section-title {
  font-weight: 500;
  color: var(--gray-637381);
}

.expander-icon {
  flex-shrink: 0;
  color: var(--grey-900);
  height: 16px;
  width: 16px;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: @space-24;
  overflow: visible;
  margin-top: @space-24;
}

@media (max-width: 768px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
}
